import { IEntityMeta, IFieldMeta } from '../interfaces/imetadata';

export class TemplateContext {
  // @ts-ignore
  private entityMeta: IEntityMeta;
  private flat: IFieldMeta[] | null = null;

  getTargetEntity(): Readonly<IEntityMeta> {
    if (!this.entityMeta) {
      throw new Error('Target entity is undefined.');
    }

    return this.entityMeta;
  }

  setTargetEntity(entityMeta: IEntityMeta): void {
    this.entityMeta = entityMeta;
    this.flat = null;
  }

  getFieldByPath(path: string): IFieldMeta | undefined {
    return this.getFields().find((f) => f.path === path);
  }

  filterFieldsByPath(path: string): IFieldMeta[] {
    const getPathToField = (field: IFieldMeta) => {
      const lastDotIndex = field.path.lastIndexOf('.');
      return lastDotIndex < 0 ? field.path : field.path.substr(0, lastDotIndex);
    };

    return this.getFields().filter((f) => {
      return getPathToField(f) === path;
    });
  }

  getFlatList(): Readonly<IFieldMeta[]> {
    return this.getFields();
  }

  private getFields(): IFieldMeta[] {
    if (this.flat) {
      return this.flat;
    }

    const flatten = (entity: IEntityMeta): IFieldMeta[] => {
      const fatList: IFieldMeta[] = [];

      const flattenImpl = (fields: IFieldMeta[] | undefined, result: IFieldMeta[]): void => {
        if (!fields) {
          return;
        }

        for (let i = 0; i < fields.length; i++) {
          const field = fields[i];
          if (!field.namespace && entity.namespace) {
            field.namespace = entity.namespace;
          }
          result.push(field);
          flattenImpl(field.fields, result);
        }
      };

      flattenImpl(entity.fields, fatList);
      return fatList;
    };

    this.flat = flatten(this.getTargetEntity());
    return this.flat;
  }
}

export const templateContext = new TemplateContext();
